import {captureException} from "@sentry/react";
import React, {useEffect} from 'react';
import {useHistory} from "react-router-dom";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import {getLSItem} from "v4/services/localStorage.service";

export default function NewsletterPage() {
    const {currentRoute} = useNavigation();
    const {replace, location: {state}} = useHistory();

    useEffect(() => {
        return () => {
            const {campaignId, ...rest} = state ?? {};

            if (campaignId) replace({state: rest});
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [replace]);

    return (
        <div className="page page-list main-content__body__slide">
            <div className="page-list__content">
                <iframe title="Mailing"
                        allow="fullscreen"
                        src={getIframeUrl(currentRoute.route.native_identifier, state)}
                        height="700"
                        width="100%"/>
            </div>
        </div>
    )
}

function getIframeUrl(nativeIdentifier, state) {
    let {sfiMailingHosts} = getLSItem('user');
    const {campaignId} = state ?? {};

    try {
        sfiMailingHosts = JSON.parse(sfiMailingHosts);
    } catch (e) {
        captureException(e);
    }

    let iframeSrc;

    switch (nativeIdentifier) {
        case 'main_mails_newsletter_create':
            iframeSrc = sfiMailingHosts?.['add_newslettersnew'];
            break;
        case 'main_mails_newsletter_manage':
            iframeSrc = sfiMailingHosts?.['list_news'];
            break;
        case 'main_mails_newsletter_journal':
            iframeSrc = sfiMailingHosts?.['journal'];
            break;
        case 'main_mails_newsletter_stats':
            iframeSrc = sfiMailingHosts?.['statsnew'];
            break;
        case 'main_mails_import':
            iframeSrc = sfiMailingHosts?.['import&pol=1'];
            break;
        case 'main_newsletter_emailing':
            iframeSrc = sfiMailingHosts?.['mail_envoi1&source=pol'];
            break;
        default:
            iframeSrc = '';
    }

    if (iframeSrc?.length > 0) {
        iframeSrc = new URL(iframeSrc);
        iframeSrc.protocol = 'https:';
        iframeSrc.searchParams.append('env', process.env.REACT_APP_ENV);

        if (campaignId) {
            iframeSrc.searchParams.append('idCampagnePol', campaignId);
        }

        iframeSrc = iframeSrc.toString();
    }

    return iframeSrc;
}
